<div class="area-mini-map">
  @if (staticImageUrl(); as url) {
    <img
      class="area-mini-map__basemap"
      alt=""
      [attr.alt]="ariaLabel()"
      [src]="url"
      [title]="ariaLabel()"
      loading="lazy"
      decoding="async"
      (error)="onStaticImageError()"
    />
  } @else {
    <svg
      class="area-mini-map__basemap area-mini-map__basemap--fallback"
      viewBox="0 0 160 90"
      preserveAspectRatio="xMidYMid slice"
      role="img"
      [attr.aria-label]="ariaLabel()"
    >
      <rect x="0" y="0" width="160" height="90" fill="#f1ece2" />
      <g fill="#e7e0cf">
        <rect x="6" y="22" width="22" height="14" rx="1" />
        <rect x="32" y="48" width="18" height="12" rx="1" />
        <rect x="56" y="14" width="14" height="10" rx="1" />
        <rect x="118" y="48" width="18" height="14" rx="1" />
        <rect x="138" y="70" width="16" height="14" rx="1" />
        <rect x="84" y="74" width="14" height="10" rx="1" />
        <rect x="14" y="66" width="18" height="12" rx="1" />
        <rect x="86" y="44" width="10" height="8" rx="1" />
      </g>
      <path d="M0,2 C 40,12 90,4 160,22 L160,0 L0,0 Z" fill="#cfe2ec" />
      <path
        d="M-4,30 C 30,40 70,18 120,30 L 170,42"
        stroke="#cfe2ec"
        stroke-width="3"
        fill="none"
        stroke-linecap="round"
      />
      <g stroke="#fdfbf6" stroke-width="0.8" stroke-linecap="round">
        <line x1="0" y1="46" x2="160" y2="42" />
        <line x1="0" y1="64" x2="160" y2="60" />
        <line x1="20" y1="0" x2="36" y2="90" />
        <line x1="60" y1="0" x2="72" y2="90" />
        <line x1="100" y1="0" x2="106" y2="90" />
        <line x1="130" y1="0" x2="138" y2="90" />
        <line x1="0" y1="78" x2="100" y2="90" />
        <line x1="60" y1="90" x2="150" y2="50" />
      </g>
      @if (focusedPath()) {
        <path
          [attr.d]="focusedPath()"
          [attr.fill]="color()"
          fill-opacity="0.30"
          [attr.stroke]="color()"
          stroke-width="2"
          stroke-linejoin="round"
        />
      }
    </svg>
  }
</div>
